import AOS from "aos";
import lozad from "lozad";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, appendCaptchaASP } from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
import jQuery from "jquery";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
});

/*==================== Aos Init ====================*/
AOS.init({
	offset: 100,
});

$(document).ready(function () {
	$('.search-mobile .search-icon, .search-mobile .search-icon-close').click(function () {
		if ($('.search-mobile').hasClass('closed')) {
			$('.search-mobile').removeClass('closed').addClass('opened');
		} else {
			$('.search-mobile').removeClass('opened').addClass('closed');
		}
	});
});


$(document).ready(function () {
	const $listCateMenu = $('.list-cate-menu');
	const $categoryDropdown = $('.category-dropdown');

	$listCateMenu.on('click', function (e) {
		e.stopPropagation();
		$categoryDropdown.toggleClass('show');
	});

	$(document).on('click', function () {
		$categoryDropdown.removeClass('show');
	});

	$categoryDropdown.on('click', function (e) {
		e.stopPropagation();
	});
});
// tab
$(document).ready(function () {

	$('.tab-category li a').click(function (e) {
		e.preventDefault();

		$('.tab-category li a').removeClass('active');
		$(this).addClass('active');

		const selectedCategory = $(this).data('category');

		$('.swiper-slide').show();

		if (selectedCategory !== 'all') {
			$('.swiper-slide').each(function () {
				const slideCategories = $(this).data('categories');
				if (!slideCategories || !slideCategories.includes(selectedCategory)) {
					$(this).hide();
				}
			});
		}

		swiper.update();
	});

	$('.tab-category li a:first').click();
});

function ButtonScrollTop() {
	jQuery(window).scroll(function () {
		if (jQuery(this).scrollTop()) {
			jQuery("#backtop").fadeIn();
		} else {
			jQuery("#backtop").fadeOut();
		}
	});
	jQuery("#backtop").click(function () {
		jQuery("html, body").animate({
			scrollTop: 0
		}, 1000);
	});
}

jQuery(document).ready(function () {
	ButtonScrollTop();
});

$(document).ready(function () {
	const $hamburger = $('.hamburger');
	const $hamburgerClose = $('.hamburger-close');
	const $menu = $('.header-menu');
	const $overlay = $('.overlay');

	function openMenu() {
		$menu.addClass('open');
		$hamburgerClose.addClass('open')
		$overlay.addClass('active');
	}

	function closeMenu() {
		$menu.removeClass('open');
		$hamburgerClose.removeClass('open');
		$overlay.removeClass('active');
	}

	$hamburger.on('click', openMenu);
	$hamburgerClose.on('click', closeMenu);
	$overlay.on('click', closeMenu);

	$(window).on('resize', function () {
		if ($(window).width() > 1023) {
			closeMenu();
		}
	});
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
